<br>
<button type="button" (click)="openBuildingModal()" id="kt_sign_in_submit"
class="btn btn-lg btn-primary">
<span class="indicator-label text-dark">Aggiungi/Ricerca Edificio</span>
</button>
<br>
<app-data-table [data]="dataSource" [columns]="columns" [displayedColumns]="displayedColumns"
    [actions]="actions" sortActive=""></app-data-table>